'use client';

import { c as _c } from "react/compiler-runtime";
import type { Provider } from '@repo/api-gw-sdk';
import { ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { ResourceTypes } from './resourceTypes';
const wipResourceTypes = [ResourceType.ResourceTypeUnspecified, ResourceType.AwsEfs, ResourceType.AwsFsx, ResourceType.AwsKeyspacesTable, ResourceType.AwsRedshift, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ResourceType.AzureFileShare, ResourceType.AzureDisk, ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm, ResourceType.AzureSqlDatabase, ResourceType.AzureSqlManagedInstance, ResourceType.AzureMysql, ResourceType.AzurePostgresql, ResourceType.AzureCosmosdbMongodb, ResourceType.AzureCosmosdbNosql, ResourceType.AzureAksNamespace, ResourceType.GcpGkeNamespace, ResourceType.GcpCloudFirestore, ResourceType.GoogleWorkspaceResource];
export const useSupportedResourceTypes = t0 => {
  const $ = _c(32);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cloudProviders = t1;
  const {
    isDemo,
    isDev
  } = useEnvironment();
  const {
    FSxSupport,
    AzureSqlDatabaseSupport,
    SapHanaPitrSupport,
    AwsRedshiftDiscoverySupport,
    AwsKeyspacesSupport,
    AwsDocumentDbSupport,
    NeptuneBackupSupport,
    AzureFilesSupport
  } = useFeatureFlags();
  let t2;
  if ($[2] !== FSxSupport) {
    t2 = FSxSupport ? [ResourceType.AwsFsx, ResourceType.AwsEfs] : [];
    $[2] = FSxSupport;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== AwsKeyspacesSupport) {
    t3 = AwsKeyspacesSupport ? [ResourceType.AwsKeyspacesTable] : [];
    $[4] = AwsKeyspacesSupport;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== AzureSqlDatabaseSupport) {
    t4 = AzureSqlDatabaseSupport ? [ResourceType.AzureSqlDatabase] : [];
    $[6] = AzureSqlDatabaseSupport;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== SapHanaPitrSupport) {
    t5 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[8] = SapHanaPitrSupport;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== AwsRedshiftDiscoverySupport) {
    t6 = AwsRedshiftDiscoverySupport ? [ResourceType.AwsRedshift] : [];
    $[10] = AwsRedshiftDiscoverySupport;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== AwsDocumentDbSupport) {
    t7 = AwsDocumentDbSupport ? [ResourceType.AwsDocumentdb] : [];
    $[12] = AwsDocumentDbSupport;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== NeptuneBackupSupport) {
    t8 = NeptuneBackupSupport ? [ResourceType.AwsNeptune] : [];
    $[14] = NeptuneBackupSupport;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== AzureFilesSupport) {
    t9 = AzureFilesSupport ? [ResourceType.AzureFileShare] : [];
    $[16] = AzureFilesSupport;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t10 = [...t2, ...t3, ...t4, ...t5, ...t6, ...t7, ...t8, ...t9];
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const ffResources = t10;
  let t11;
  if ($[27] !== cloudProviders || $[28] !== ffResources || $[29] !== isDemo || $[30] !== isDev) {
    t11 = Object.values(ResourceType).filter(x => x !== ResourceType.ResourceTypeUnspecified && (cloudProviders.length ? cloudProviders.includes(ResourceTypes[x]?.provider) : true) && (isDemo || isDev || !wipResourceTypes.includes(x) || ffResources.includes(x)));
    $[27] = cloudProviders;
    $[28] = ffResources;
    $[29] = isDemo;
    $[30] = isDev;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};